(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const editor = document.documentElement.classList.contains('shopify-design-mode');
  const revealSelector = [
    '.gz-hero__copy > *', '.gz-section-heading', '.gz-feature__copy', '.gz-feature__media',
    '.gz-collection-card', '.gz-editorial__copy', '.gz-editorial__visual',
    '.gz-value-grid > div', '.gz-steps-grid > div', '.gz-detail-list > div',
    '.gz-journal article', '.gz-community-invite > *', '.gz-testimonial-grid figure',
    '.gz-service__item', '.gz-faq > div', '.gz-contact > div', '.gz-newsletter__inner > div',
    '#MainContent .resource-list__item', '#MainContent .product-grid__item', '.preview-product-grid > div',
    '#MainContent .product-details', '#MainContent .cart-page__title', '.gz-page__content',
    '.gz-page > h1', '.gz-breadcrumbs', '.gz-footer__grid > div'
  ].join(',');
  let observer;
  function show(element) {
    element.classList.remove('gz-motion-pending');
    element.classList.add('gz-motion-visible');
    observer?.unobserve(element);
  }
  function setup(scope = document) {
    scope.querySelectorAll('[data-gz-marquee]').forEach(ribbon => {
      if (ribbon.dataset.gzMotionReady) return;
      ribbon.dataset.gzMotionReady = 'true';
      const button = ribbon.querySelector('.gz-ribbon-toggle');
      button?.addEventListener('click', () => {
        const paused = ribbon.classList.toggle('gz-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Resume sliding text' : 'Pause sliding text');
      });
    });
    if (reducedMotion.matches || editor || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.gz-motion-pending').forEach(show);
      return;
    }
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { if (entry.isIntersecting) show(entry.target); });
    }, { threshold: 0.06, rootMargin: '0px 0px -20px 0px' });
    scope.querySelectorAll(revealSelector).forEach(element => {
      if (element.classList.contains('gz-motion-target')) return;
      const siblings = [...element.parentElement.children];
      const index = siblings.indexOf(element);
      element.style.setProperty('--gz-reveal-delay', `${Math.min(index % 4, 3) * 65}ms`);
      element.classList.add('gz-motion-target', 'gz-motion-pending');
      observer.observe(element);
    });
  }
  function start() {
    setup();
    // Native filtering and theme-editor section replacements can add new cards.
    const main = document.getElementById('MainContent');
    if (main) {
      let frame;
      new MutationObserver(records => {
        if (!records.some(record => record.addedNodes.length)) return;
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = null; setup(main); });
      }).observe(main, { childList: true, subtree: true });
    }
  }
  document.addEventListener('focusin', event => {
    let element = event.target;
    while (element && element !== document) {
      if (element.classList?.contains('gz-motion-pending')) show(element);
      element = element.parentElement;
    }
  });
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches) document.querySelectorAll('.gz-motion-pending').forEach(show);
    else setup();
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const editor = document.documentElement.classList.contains('shopify-design-mode');
  let frame = 0, target = 0, lastTime = 0;
  const clamp = value => Math.max(0, Math.min(value, document.documentElement.scrollHeight - innerHeight));
  function stop() {
    cancelAnimationFrame(frame); frame = 0; lastTime = 0;
    document.documentElement.classList.remove('gz-wheel-easing');
  }
  function nestedScroll(event) {
    for (const element of event.composedPath()) {
      if (!(element instanceof Element) || element === document.body || element === document.documentElement) continue;
      if (element.matches('input,textarea,select,[contenteditable="true"],dialog,[role="dialog"],.cart-drawer,.menu-drawer,.search-modal')) return true;
      const style = getComputedStyle(element);
      if (/(auto|scroll)/.test(style.overflowY) && element.scrollHeight > element.clientHeight + 1) return true;
    }
    return false;
  }
  function step(time) {
    const delta = Math.min(48, lastTime ? time - lastTime : 16);
    lastTime = time; target = clamp(target);
    const distance = target - scrollY;
    if (Math.abs(distance) < 4) { window.scrollTo({ top: target, behavior: 'instant' }); stop(); return; }
    window.scrollTo({ top: scrollY + distance * (1 - Math.exp(-delta / 100)), behavior: 'instant' });
    frame = requestAnimationFrame(step);
  }
  window.addEventListener('wheel', event => {
    if (reduced.matches || !fine.matches || editor || event.ctrlKey || event.metaKey || event.defaultPrevented || Math.abs(event.deltaX) > Math.abs(event.deltaY) || !event.deltaY || nestedScroll(event)) return;
    if (getComputedStyle(document.body).overflowY === 'hidden' || getComputedStyle(document.documentElement).overflowY === 'hidden') return;
    const amount = event.deltaY * (event.deltaMode === 1 ? 32 : event.deltaMode === 2 ? innerHeight : 1);
    const next = clamp((frame ? target : scrollY) + amount);
    if (next === scrollY && !frame) return;
    event.preventDefault(); target = next;
    document.documentElement.classList.add('gz-wheel-easing');
    if (!frame) frame = requestAnimationFrame(step);
  }, { passive: false });
  // Keyboard, scrollbar dragging, anchors and focus retain native control.
  window.addEventListener('keydown', event => { if (['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(event.key)) stop(); }, { passive: true });
  window.addEventListener('pointerdown', stop, { passive: true });
  window.addEventListener('touchstart', stop, { passive: true });
  window.addEventListener('hashchange', stop);
  document.addEventListener('focusin', stop);
  reduced.addEventListener('change', stop);
  window.addEventListener('resize', stop, { passive: true });
  let imageFrame;
  function updateImages() {
    imageFrame = null;
    if (reduced.matches || editor) return;
    document.querySelectorAll('.gz-feature__media,.gz-editorial__visual,.gz-style-panel__image').forEach(element => {
      const rect = element.getBoundingClientRect();
      if (rect.height && rect.top < innerHeight && rect.bottom > 0) {
        const progress = Math.max(-1, Math.min(1, ((rect.top + rect.height / 2) - innerHeight / 2) / innerHeight));
        element.style.setProperty('--gz-image-shift', `${(-progress * 14).toFixed(2)}px`);
        element.classList.add('gz-image-alive');
      }
    });
  }
  window.addEventListener('scroll', () => { if (!imageFrame) imageFrame = requestAnimationFrame(updateImages); }, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateImages); else updateImages();
})();


